import { render, staticRenderFns } from "./validation_tooltip.vue?vue&type=template&id=315ee70a"
import script from "./validation_tooltip.vue?vue&type=script&lang=js"
export * from "./validation_tooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports